"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryImageTypes = exports.SentryTag = exports.SentrySpan = exports.SentryOperation = exports.SentryTransaction = exports.MonitoringStatus = void 0;
/**
 * The status of an Transaction/Span.
 */
var MonitoringStatus;
(function (MonitoringStatus) {
    /** The operation completed successfully. */
    MonitoringStatus["OK"] = "ok";
    /** Unknown. Any non-standard HTTP status code. */
    MonitoringStatus["UNKNOWN_ERROR"] = "unknown_error";
    /** The operation was cancelled (typically by the user). */
    MonitoringStatus["CANCELLED"] = "cancelled";
    /** The operation was aborted, typically due to a concurrency issue. */
    MonitoringStatus["ABORTED"] = "aborted";
})(MonitoringStatus = exports.MonitoringStatus || (exports.MonitoringStatus = {}));
/**
 * The name of entities in Sentry
 */
var SentryTransaction;
(function (SentryTransaction) {
    SentryTransaction["PICTURE_PROCESSING"] = "Picture Processing";
})(SentryTransaction = exports.SentryTransaction || (exports.SentryTransaction = {}));
var SentryOperation;
(function (SentryOperation) {
    SentryOperation["IMAGES_OCR"] = "Image OCR";
    SentryOperation["DAMAGE_DETECTION"] = "Damage Detection";
    SentryOperation["ADD_DAMAGE"] = "Add Damage";
    SentryOperation["CAPTURE_TOUR"] = "Capture Tour";
    SentryOperation["CAPTURE_SIGHT"] = "Capture Sight";
})(SentryOperation = exports.SentryOperation || (exports.SentryOperation = {}));
var SentrySpan;
(function (SentrySpan) {
    SentrySpan["TAKE_PIC"] = "Take Pic";
    SentrySpan["CREATE_THUMBNAIL"] = "Create Thumbnail";
    SentrySpan["UPLOAD_PIC"] = "Upload Pic";
})(SentrySpan = exports.SentrySpan || (exports.SentrySpan = {}));
var SentryTag;
(function (SentryTag) {
    SentryTag["INSPECTION_ID"] = "inspectionId";
    SentryTag["SIGHT_ID"] = "sightId";
    SentryTag["TASK"] = "task";
    SentryTag["IS_SKIP"] = "isSkip";
    SentryTag["IS_RETAKE"] = "isRetake";
    SentryTag["TAKEN_PICTURES"] = "takenPictures";
    SentryTag["ADD_DAMAGES"] = "addDamages";
    SentryTag["NON_COMPLIANCE_PICS"] = "nonCompliancePics";
    SentryTag["PERCENT_OF_NON_COMPLIANCE_PICS"] = "percentOfNonCompliancePics";
    SentryTag["IMAGE_TYPE"] = "imageType";
})(SentryTag = exports.SentryTag || (exports.SentryTag = {}));
var SentryImageTypes;
(function (SentryImageTypes) {
    SentryImageTypes["CAPTURE"] = "capture";
    SentryImageTypes["ZOOM"] = "zoom";
    SentryImageTypes["RETAKE"] = "retake";
})(SentryImageTypes = exports.SentryImageTypes || (exports.SentryImageTypes = {}));
//# sourceMappingURL=types.js.map